var _path, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgArrowRight = function SvgArrowRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#Arrow-Right_svg__a)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "Arrow-Right_svg__b",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 2,
    width: 14,
    height: 12
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.6 8.001H2.2M9.8 3.5l4 4.5-4 4.5",
    stroke: "#000",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#Arrow-Right_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#14161A",
    d: "M0 16V0h16v16z"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "Arrow-Right_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h16v16H0z"
  })))));
};
export { SvgArrowRight as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgY2xpcC1wYXRoPSJ1cmwoI2NsaXAwXzM3ODVfMjA4NDU1KSI+CjxtYXNrIGlkPSJtYXNrMF8zNzg1XzIwODQ1NSIgc3R5bGU9Im1hc2stdHlwZTphbHBoYSIgbWFza1VuaXRzPSJ1c2VyU3BhY2VPblVzZSIgeD0iMSIgeT0iMiIgd2lkdGg9IjE0IiBoZWlnaHQ9IjEyIj4KPHBhdGggZD0iTTEzLjU5OTQgOC4wMDA5OEwyLjE5OTM3IDguMDAwOTgiIHN0cm9rZT0iYmxhY2siIHN0cm9rZS13aWR0aD0iMS41IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPHBhdGggZD0iTTkuNzk5MzIgMy41MDA4NUwxMy43OTkzIDguMDAwODVMOS43OTkzMiAxMi41MDA5IiBzdHJva2U9ImJsYWNrIiBzdHJva2Utd2lkdGg9IjEuNSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+CjwvbWFzaz4KPGcgbWFzaz0idXJsKCNtYXNrMF8zNzg1XzIwODQ1NSkiPgo8cmVjdCB4PSIwLjAwMDQ4ODI4MSIgeT0iMTYuMDAwMiIgd2lkdGg9IjE2IiBoZWlnaHQ9IjE2IiB0cmFuc2Zvcm09InJvdGF0ZSgtOTAgMC4wMDA0ODgyODEgMTYuMDAwMikiIGZpbGw9IiMxNDE2MUEiLz4KPC9nPgo8L2c+CjxkZWZzPgo8Y2xpcFBhdGggaWQ9ImNsaXAwXzM3ODVfMjA4NDU1Ij4KPHJlY3Qgd2lkdGg9IjE2IiBoZWlnaHQ9IjE2IiBmaWxsPSJ3aGl0ZSIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMCAwLjAwMDg1NDQ5MikiLz4KPC9jbGlwUGF0aD4KPC9kZWZzPgo8L3N2Zz4K";